import { useTranslation } from 'react-i18next';

export const TableList = ({ dataTable }) => {

    const { t } = useTranslation();

    return (
        <div className="component-table-default">
            <div className="responsive-table">
                <table>
                    <tbody>
                        {
                            dataTable.map(data => (
                                data && (<tr key={data.label}>
                                    <td className={(
                                        data.value === 'Reprobado' || data.value === 'Incorrecto' ||
                                        data.value === 'Indeterminado' || data.value === 'Indeterminada' ||
                                        data.value === 'Revocado' || data.value === 'Expirado' ||
                                        data.label === t('validated.error-message') || data.label === t('validated.alert-message')
                                    ) ? 'item-indeterminado' : ''}> {data.label} </td>
                                    <td> {data.value} </td>
                                </tr>)
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};
